<template>
  <div>
    <van-popup v-model="showDateSelect" :close-on-click-overlay="false" @closed="onClosed">
      <div class="titleRect">
        商品定做信息
        <div class="closeButton">
          <i class="iconfont iconclosex" @click="onClose" />
        </div>
      </div>
      <div v-if="data" class="rect">
        <div class="img">
          <van-swipe :autoplay="5000">
            <van-swipe-item v-for="(image, index) in images" :key="index">
              <img v-lazy="image">
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="title">
          潜水资质
        </div>
        <buttonSelect v-model="certification" :typelist="certificationList" @onChange="onCertificationChange" />
        <template v-if="data&& data.diyType==='CIRCULAR_SEAL'">
          <div class="title">
            昵称
          </div>
          <van-field v-model="nickName" placeholder="请输入英文(拼音)昵称" @blur="onNickNameBlur" />
        </template>
        <template v-if="data&& data.diyType==='CARD'">
          <div class="title">
            头像
          </div>
          <img v-if="headIconSrc" :src="headIconSrc" class="headIcon" @click="showUploadHead=true">
          <div v-if="!headIconSrc" class="upTitle" @click="showUploadHead=true">
            上传照片
          </div>
        </template>
        <van-button type="danger" size="small" style="width:100%" :color="GetColorMain()" @click="onChange">确定</van-button>

      </div>
    </van-popup>
    <uploadUserHead v-model="showUploadHead" @change="onUploadHeadChange" />
  </div>
</template>
<script>
import request from '@/utils/request'
import { DatetimePicker, Popup, Field, Button, Toast, Swipe, SwipeItem } from 'vant'
import buttonSelect from '@/components/buttonSelect'
import { MyNotify, GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine, UrlBase64 } from '@/utils/base'
import uploadUserHead from '@/components/uploadUserHead'
import { getToken } from '@/utils/auth'
// import { formatDate } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    [DatetimePicker.name]: DatetimePicker,
    [Popup.name]: Popup,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    buttonSelect,
    uploadUserHead
  },
  props: {
    // eslint-disable-next-line
    specificationId:undefined,
    // eslint-disable-next-line
    value: Boolean,
  },
  data() {
    return {
      showDateSelect: false,
      id: undefined,
      data: undefined,
      certifications: [],
      certificationList: [],
      certification: undefined,
      certificationId: undefined,
      certificationGroup: undefined,
      cerificateName: undefined,
      nickName: '',
      showUploadHead: false,
      headIconSrc: undefined,
      headIconBase: undefined,
      images: []
    }
  },
  watch: {
    value(newValue) {
      if (newValue) {
        this.showDateSelect = true
        setTimeout(() => {
          this.init()
          this.initUserHeadIcon()
        }, 5)
      }
    },
    specificationId(newValue) {
      console.log('specificationID', newValue)
      if (newValue) {
        this.id = newValue
      }
    }
  },
  created() {

  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    onClose() {
      this.showDateSelect = false
    },
    initUserHeadIcon() {
      request({
        url: '/User/getUserHeadIcon',
        method: 'get'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.headIconSrc = response.data.headIcon
        this.headIconBase = response.data.headIconScore
      })
    },
    onUploadHeadChange(data) {
      Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: '上传照片中,请稍等'
      })
      request({
        url: '/User/updateUserHeadIcon',
        method: 'post',
        data: { data: data }
      }).then(response => {
        Toast.clear()
        if (!response.success) {
          return
        }
        this.headIconSrc = response.data.headIcon
        this.headIconBase = response.data.headIconScore
        this.updateDiyUrl()
        MyNotify('success', '照片上传成功')
      })
    },
    init() {
      request({
        url: '/Store/GetCommodityDiyConfig',
        method: 'post',
        params: { id: this.id }
      }).then(response => {
        if (!response.success) {
          return
        }
        this.data = response.data
        this.getUserVerificate(() => {
          this.certificationList = []
          this.certifications.forEach(item => {
            var line = {
              select: item.cerificateId === this.certificationId,
              text: item.cerificateName + '(' + item.groupTeam + ')',
              value: item.cerificateId,
              disabled: false
            }
            if (this.data.diyType === 'CARD' && this.data.supportrGroupTeam != null) {
              var a = this.data.supportrGroupTeam & item.groupTeamNum
              // console.log('测试a:', item.groupTeam + ' ' + item.groupTeamNum + ' ' + a)
              line.disabled = a <= 0
            }
            this.certificationList.push(line)
          })
          this.updateDiyUrl()
        })
      })
    },
    onClosed() {
      this.$emit('input', false)
    },
    onChange() {
      if (this.data.diyType === 'CIRCULAR_SEAL') {
        if (this.nickName.length < 1) {
          MyNotify('error', '请输入昵称(英文)')
          return
        }
        if (/.*[\u4e00-\u9fa5]+.*$/.test(this.nickName)) {
          MyNotify('error', '昵称不能含有汉字')
          return
        }
      }
      if (this.data.diyType === 'CARD') {
        if (!this.headIconBase) {
          MyNotify('error', '请上传头像')
          return
        }
        this.nickName = this.cerificateName
      }
      if (!this.certificationId || this.certificationId.length <= 0) {
        MyNotify('error', '请选择资质证书')
        return
      }
      this.$emit('onChange', {
        title: this.nickName,
        nickName: this.nickName,
        certificateId: this.certificationId,
        certificateTeam: this.certificationGroup,
        extendedData: this.headIconBase
      })
      this.showDateSelect = false
    },
    onNickNameBlur() {
      this.updateDiyUrl()
    },
    onCertificationChange() {
      this.updateDiyUrl()
    },
    updateDiyUrl() {
      if (this.certification) {
        let selectCertification = null
        this.certifications.forEach(item => {
          if (item.cerificateId === this.certification.value) {
            selectCertification = item
          }
        })
        this.certificationId = selectCertification ? selectCertification.cerificateId : ''
        this.certificationGroup = selectCertification ? selectCertification.groupTeam : ''
        this.cerificateName = selectCertification ? selectCertification.cerificateName : ''
      }
      const url = this.data.diyIcon +
        '?specificationId=' + this.id +
         '&nickName=' + encodeURIComponent(this.nickName) +
         '&certificateTeam=' + encodeURIComponent(this.certificationGroup) +
         '&certificateId=' + encodeURIComponent(this.certificationId) +
         '&extendedData=' + (this.headIconBase ? encodeURIComponent(this.headIconBase) : '') +
         '&token=' + UrlBase64(getToken())
      if (this.data.diyType === 'CIRCULAR_SEAL') {
        if (this.images.length === 1 && this.images[0] === url) {
          return
        }
        this.images = []
        this.images.push(url)
      } else if (this.data.diyType === 'CARD') {
        const url1 = url + '&id=0'
        const url2 = url + '&id=1'
        if (this.images.length === 2 && this.images[0] === url1 && this.images[1] === url2) {
          return
        }
        this.images = []
        this.images.push(url1)
        this.images.push(url2)
      }
    },
    getUserVerificate(callback) {
      request({
        url: '/user/getUserCertificate',
        method: 'post'
      }).then(response => {
        if (!response.success) {
          return
        }
        this.certifications = response.data.list
        if (callback) {
          callback()
        }
      })
    }
  }
}
</script>

<style scoped>
.titleRect{
    text-align: center;
    border-bottom: 1px solid #cacaca;
    line-height: 2.4em;
    position: relative;
}
.titleRect .closeButton{
    position: absolute;
    right: 0.5em;
    top:0;

}
.title{
    margin-top: 0.5em;
    font-size: 0.9em;
}
.rect{
    width:86vw;
    padding: 2vw;
}
.rect .img{
    text-align: center;
}
.rect .img img{
    width: 80%;
}
.headIcon{
  width: 4em;
}
.upTitle{
  margin: 1em 0;
  padding: 0.5em;
  border:1px solid #cacaca;
}
</style>
